export default "/images/cbb44e42c2bfc0b50f695ca5557f0a2f.jpg";